import { createSelector } from '@reduxjs/toolkit';
import { getRangeValue } from '../../../packages/JsonQuery';
import { DEFAULT_RANGE_VALUE } from 'shared/constants/defaultValues';
import { selectJsonQuery } from './selectJsonQuery';

export const selectConstructionYear = createSelector(
  selectJsonQuery,
  jsonQuery => getRangeValue('house_year')(jsonQuery) || DEFAULT_RANGE_VALUE,
);
